// Single source of truth for event categories, so the Explore filters and the
// organiser/admin event forms never drift out of sync.
export const CATEGORIES = [
  { value: 'sports', label: 'Sports' },
  { value: 'festival', label: 'Festival' },
  { value: 'fashion', label: 'Fashion' },
  { value: 'networking', label: 'Networking' },
  { value: 'nightlife', label: 'Nightlife' },
  { value: 'painting', label: 'Painting' },
  { value: 'entrepreneurship', label: 'Entrepreneurship' },
  { value: 'workshops', label: 'Workshops' },
  { value: 'kids', label: 'Kids' },
  { value: 'students', label: 'Students' },
  { value: 'other', label: 'Other' },
];

export const CATEGORY_LABELS = CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label;
  return acc;
}, {});

export const CATEGORY_COLORS = {
  sports: 'bg-blue-500/20 text-blue-400',
  festival: 'bg-purple-500/20 text-purple-400',
  fashion: 'bg-pink-500/20 text-pink-400',
  networking: 'bg-green-500/20 text-green-400',
  nightlife: 'bg-yellow-500/20 text-yellow-400',
  painting: 'bg-orange-500/20 text-orange-400',
  entrepreneurship: 'bg-teal-500/20 text-teal-400',
  workshops: 'bg-indigo-500/20 text-indigo-400',
  kids: 'bg-rose-500/20 text-rose-400',
  students: 'bg-sky-500/20 text-sky-400',
  other: 'bg-gray-500/20 text-gray-400',
};

export const EUROPEAN_COUNTRIES = [
  'Albania', 'Austria', 'Belarus', 'Belgium', 'Bosnia and Herzegovina',
  'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia',
  'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Iceland', 'Ireland',
  'Italy', 'Kosovo', 'Latvia', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Malta', 'Moldova', 'Monaco', 'Montenegro', 'Netherlands', 'North Macedonia',
  'Norway', 'Poland', 'Portugal', 'Romania', 'San Marino', 'Serbia',
  'Slovakia', 'Slovenia', 'Spain', 'Sweden', 'Switzerland', 'Ukraine',
  'United Kingdom', 'Vatican City',
];

export const SUGGESTED_TAGS = ['free', '18+', 'polish', 'english'];
